module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.6754/img/cms-free-signup.png"